import { Dialog } from "../dialog/dialog";
import { Toast } from "../dialog/toast";
import { Razor } from "../razor/razor";

export class DbInterfacer {
	constructor(id) {
		this.ID = parseInt(id);

		this.GetPayload = this.GetPayload.bind(this);

		this.ResourceURL = "";

		this.SaveHandler = "Save";
		this.DeleteHandler = "Delete";
		this.RestoreHandler = "Restore";

		this.DeleteMessage = "";

		this.Title = "name";

		this.EditConfig = {
			PartialView: "",
			Payload: this.GetPayload,
			InvalidData: this.GetInvalidData,
			PartialViewOptions: { ID: this.ID },
			Title: "",
			Body: "",
			NewInstanceTitle: "",
			Size: "md",
			Theme: "FORM",
			AffirmativeText: this.ID === 0 ? "Create" : "Save",
			Handler: this.SaveHandler
		}
	}

	static OnSave = response => location.href = response.url;
	static OnDelete = null;
	static OnRestore = null;

	async GetDetails() {
		return (await Ajax.Get(`~/${this.ResourceURL}/${this.ID}?handler=JSON`)).body;
	}

	async Edit(options) {
		options = { ...this.EditConfig, ...options };
		const { Theme, Size, AffirmativeText } = options;

		if (!options.Title && this.ID !== 0) {
			options.Title = typeof this.Title === "string"
				? (await this.GetDetails())[this.Title]
				: this.Title?.();
		}
		const dialogOptions = {
			Theme, Size, AffirmativeText, ...(options.DialogOptions ?? {})
		};

		if (!dialogOptions.OnCheckValid) {
			dialogOptions.OnCheckValid = dialog => this.#CanSave(dialog, options);
		}

		Dialog.ShowPartialView(this.ID === 0 ? options.NewInstanceTitle : options.Title, options.Body, options.PartialView,
			options.PartialViewOptions, dialogOptions).then(proceed => {
				if (proceed) {
					this.Save(options);
				}
			});
	}

	GetInvalidData(dialog) {
		return [...dialog.querySelectorAll(".input-field:not(chip-input .input-field)")].filter(x => x.checkValidity?.() === false);
	}
	GetPayload() { return {}; }

	#CanSave(dialog, options) {
		let failedInputs = options.GetInvalidData ?? this.GetInvalidData;
		failedInputs = [...new Set(failedInputs(dialog).concat([...dialog.querySelectorAll("chip-input, chip-dropdown")].filter(x => x.reportValidity() === false)))];

		dialog.querySelectorAll(".input-field__invalid").forEach(x => x.classList.remove("input-field__invalid"));

		if (!failedInputs.length) {
			return true;
		} else {
			failedInputs.forEach(x => {
				let target = x.nodeName === "INPUT" ? x : x.querySelector("input");
				target ??= x;

				target.classList.add("input-field__invalid");
			});
			return false;
		}
	}

	Save(options = {}) {
    debugger;
		Ajax.Post(`~/${this.ResourceURL}/${this.ID}?handler=${options.Handler ?? this.SaveHandler}`, {
			body: options.Payload ? options.Payload() : this.GetPayload(),
			success: {
				ok: response => {
          debugger;
					Toast.ShowSuccess("Your changes have been saved successfully");

					if (options.OnSave) {
						options.OnSave(response);
					} else {
						this.constructor.OnSave?.(response);
					}
				},
				400: response => {
          debugger;
					const reason = Razor.GetBadRequestReason(response);
					Dialog.ShowWarning("That doesn't look right", reason);
				}
			}
		});
	}

	async Delete(handler) {
		const title = typeof this.Title === "string"
			? (await this.GetDetails())[this.Title]
			: this.Title?.();

		let message = title ? `Are you sure you'd like to delete '${title}'?` : "Are you sure you'd like to delete this?";

		if (this.DeleteMessage) {
			message = this.DeleteMessage;
		}

		Dialog.ShowConfirmation("Are you sure?", message).then(proceed => {
			if (proceed) {
				Ajax.Post(`~/${this.ResourceURL}/${this.ID}?handler=${handler ?? this.DeleteHandler}`, {
					success: {
						ok: response => {
							Toast.ShowSuccess(title ? `'${title}' was deleted successfully` : "Deleted successfully");

							this.constructor.OnSave?.(response);
							this.constructor.OnDelete?.(response);
						}
					}
				});
			}
		})
	}

	async Restore(handler) {
		const title = typeof this.Title === "string"
			? (await this.GetDetails())[this.Title]
			: this.Title?.();

		Dialog.ShowConfirmation("Are you sure?", title ? `Are you sure you'd like to restore '${title}'` : "Are you sure you'd like to restore this?").then(proceed => {
			if (proceed) {
				Ajax.Post(`~/${this.ResourceURL}/${this.ID}?handler=${handler ?? this.RestoreHandler}`, {
					success: {
						ok: response => {
							Toast.ShowSuccess(title ? `'${title}' was restored successfully` : "Restored successfully");

							this.constructor.OnSave?.(response);
							this.constructor.OnRestore?.(response);
						}
					}
				});
			}
		})
	}
}
